module.exports = __webpack_public_path__ + "static/media/3_Garden_Sector_A_new.6e2cc8a9.jpg";